module.exports = __webpack_public_path__ + "assets/images/stopwatch.709b9f3855020f5d4b9e20ad756339d1.svg";